import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Toaster } from "./ui/sonner";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-ivory text-ink">
      <Navbar />
      <main className="flex-1 pt-[72px] lg:pt-[84px]">{children}</main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}
